import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "image", "placeholder", "select" ]

  connect() {
    this.actuate()
  }

  change(){
    this.actuate()
  }

  actuate(){
    const selectedOption = this.selectTarget.options[this.selectTarget.selectedIndex];
    const image = selectedOption.dataset["image"];

    this.placeholderTarget.classList.add("hidden")
    this.imageTarget.classList.add("hidden");

    if (image) {
      this.imageTarget.src = image;
      this.imageTarget.classList.remove("hidden");
    } else {
      this.placeholderTarget.classList.remove("hidden");
    }
  }
}
